/**
 * Per-client skip reasons persisted in a generation run's metadata
 * (`metadata.skippedClients`, S1/T34). `code` is the stable machine-readable
 * token for the generator branch; `reason` is the human message for the
 * operator.
 */
export interface GeneracionSkippedClient {
  idCliente: number;
  code: string;
  reason: string;
}

/**
 * Reads `metadata.skippedClients` defensively so the recovery panel never
 * breaks on older runs (whose metadata predates S1/T34) or on malformed
 * entries: anything unrecognised is ignored instead of rendered.
 */
export function parseGeneracionSkippedClients(
  metadata: Record<string, unknown> | null | undefined,
): GeneracionSkippedClient[] {
  const raw = metadata?.skippedClients;
  if (!Array.isArray(raw)) {
    return [];
  }
  return raw.flatMap((entry) => {
    if (typeof entry !== 'object' || entry === null) {
      return [];
    }
    const { idCliente, code, reason } = entry as Record<string, unknown>;
    if (typeof idCliente !== 'number' || typeof code !== 'string' || typeof reason !== 'string') {
      return [];
    }
    return [{ idCliente, code, reason }];
  });
}
